module.exports = __webpack_public_path__ + "static/img/paypal.ce85250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/paypal.png
// module id = a1qb
// module chunks = 1